import {Controller} from "stimulus";

let start_time;

export default class extends Controller {
  static targets = ["currentCall", "callCenter", "timer", "noteForm", "home", "edit", "contactActive", "contactClosed", "reminderDate", "comment", "workspace", "address"];


  initialize() {
    this.dashboard = document.getElementById('contact-dashboard');
    this.detail = document.getElementById('contact-detail');
    if (this.data.get('url')) {
      this.loadCall(this.data.get('url'));
    }
  }

  get fetch_headers() {
    return {
      'Accept': 'application/json, text/html',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
  }

  copyAddress() {
    this.addressTarget.select();
    document.execCommand("copy");
  }

  updateUrl() {
    this.data.set('url', this.currentCallTarget.dataset.url);
  }

  addNote(e) {
    if (e.currentTarget.value === '') {
      return true;
    }
    let data = e.currentTarget.options[e.currentTarget.selectedIndex].dataset;
    this.commentTarget.value = data.comment;
    if (data.close === 'true') {
      this.contactClosedTarget.checked = true;
    }
    else {
      this.contactActiveTarget.checked = true;
    }
    if (data.reminder) {
      this.reminderDateTarget.value = data.reminder;
    }
    else {
      this.reminderDateTarget.value = '';
    }
    e.currentTarget.value = '';
    this.hideScreen(this.homeTarget);
    this.hideScreen(this.editTarget);
    this.showScreen(this.noteFormTarget);
  }

  cancelNote(e) {
    this.hideScreen(this.noteFormTarget);
    this.showScreen(this.homeTarget);
  }

  sendNote(e) {
    if (this.commentTarget.value == '') {
      alert('Please add a comment');
      return;
    }
    let status = this.closeContactTarget.checked ? 'closed' : 'active'
    let data = {user_contact:{last_comment:this.commentTarget.value, status:status}}
    if (this.reminderDateTarget.value != '') {
      data.user_contact.call_reminder = this.reminderDateTarget.value
    }
    this.sendUpdate(data, status);
  }

  sendMessage(e) {
    let select = e.currentTarget;
    if (select.value === '') {
      return true;
    }
    let option = select.options[select.selectedIndex];
    if (confirm('Do you want to ' + option.dataset.confirm + ' to this contact?')) {
      this.sendUpdate({message:select.value}, null)
    }
    e.currentTarget.value = '';
  }

  refresh() {
    clearInterval(this.timer);
    this.loadCall(this.data.get('url'));
  }

  loadCall(url) {
    fetch(url, {
      method: 'GET',
      headers: this.fetch_headers
    }).then(response => response.text())
      .then(html => {
        this.element.innerHTML = html;
        this.showInterface();
        this.startTimer(new Date(parseInt(this.timerTarget.dataset.time)));
        document.dispatchEvent(new CustomEvent('dashboard.call.started', {detail: {id:this.currentCallTarget.dataset.id, contact:this.currentCallTarget.dataset.contact}}));
      });
  }

  startCall(url) {
    var token = document.head.querySelector("[name=csrf-token]").content;
    var body = JSON.stringify({authenticity_token: token});
    fetch(url, {
      method: 'POST',
      headers: this.fetch_headers,
      body: body
    }).then(response => response.text())
      .then(html => {
        this.element.innerHTML = html;
        this.showInterface();
        this.startTimer(Date.now());
        this.updateUrl();
        document.dispatchEvent(new CustomEvent('dashboard.call.started', {detail: {id:this.currentCallTarget.dataset.id, contact:this.currentCallTarget.dataset.contact}}));
      });
  }

  endCall() {
    if (!this.hasCurrentCallTarget) {
      return;
    }
    let token = document.head.querySelector("[name=csrf-token]").content;
    let body = JSON.stringify({authenticity_token: token});
    fetch(this.currentCallTarget.dataset.url, {
      method: 'DELETE',
      headers: this.fetch_headers,
      body: body
    }).then(response => response.text())
      .then(html => {
        clearInterval(this.timer);
        this.hideInterface();
        document.dispatchEvent(new CustomEvent('dashboard.call.ended', {detail: {id:this.currentCallTarget.dataset.id, contact:this.currentCallTarget.dataset.contact}}));
        this.element.innerHTML = '';
      });
  }

  editUser(e) {
    let url = e.currentTarget.dataset.url;
    console.log(url);
    fetch(url, {
      method: 'GET',
      headers: this.fetch_headers
    }).then(response => response.text())
      .then(html => {
        this.editTarget.innerHTML = html;
        this.hideScreen(this.homeTarget);
        this.hideScreen(this.noteFormTarget);
        this.showScreen(this.editTarget);
      });
  }

  cancelEdit() {
    this.hideScreen(this.editTarget);
    this.showScreen(this.homeTarget);
    this.editTarget.innerHTML = '';
  }

  hideScreen(screen) {
    if (screen.style.display !== 'none') {
      screen.setAttribute('data-original-display', screen.style.display);
      screen.style.display = 'none';
    }
  }

  showScreen(screen) {
    screen.style.display = screen.getAttribute('data-original-display');
  }

  sendUpdate(data, status) {
    if (!this.hasCurrentCallTarget) {
      return;
    }
    data.authenticity_token = document.head.querySelector("[name=csrf-token]").content;
    let body = JSON.stringify(data);
    fetch(this.currentCallTarget.dataset.url, {
      method: 'PUT',
      headers: this.fetch_headers,
      body: body
    }).then(response => response.text())
      .then(html => {
        if (status == 'closed') {
          this.endCall();
        }
        else {
          this.element.innerHTML = html;
        }
      });
  }

  startTimer(date) {
    start_time = date;
    this.updateTime();
    this.timer = setInterval(() => {
      this.updateTime()
    }, 500)
  }

  updateTime() {
    let seconds = (Date.now() - start_time) / 1000;
    const format = val => `0${Math.floor(val)}`.slice(-2)
    let hours = seconds / 3600
    let minutes = (seconds % 3600) / 60
    this.timerTarget.innerHTML = [hours, minutes, seconds %= 60].map(format).join(':')
  }

  showInterface() {
    this.dashboard.setAttribute('data-original-display', this.dashboard.style.display);
    this.dashboard.style.display = 'none';
    this.detail.setAttribute('data-original-display', this.detail.style.display);
    this.detail.style.display = 'none';
    this.element.style.display = 'block';
  }

  hideInterface() {
    this.dashboard.style.display = this.dashboard.getAttribute('data-original-display');
    this.detail.style.display = this.detail.getAttribute('data-original-display');
    this.element.style.display = 'none';
  }



}